<template>
    <div v-if="!loading && !!ifConditionIsValid"  :class="customClass">
        <slot name="ifproperty" />
    </div>
</template>

<script>

    export default {

        props: {
            conditionType: { type: String, default: '' },
            customClass: { type: String, default: '' },
            listProperties: { type: String, default: '' },
        },

        computed: {

          ifConditionIsValid () {
              // console.log("ifConditionIsValid");
              let res = false;
              if(this.isOR){
                // this.currentPropertyIds => [1,2,5,6]
                // this.currentPropertyIdsValues => ["2:45", "5:345", ]
                // this.listOfPropertiesMixed => userEntry in array = [1, 2, "2:45", 5]
                let isCurrentPropertiesInList =  (this.intersect(this.listOfPropertiesMixed, this.currentPropertyIds).length > 0 || this.intersect(this.listOfPropertiesMixed, this.currentPropertyIdsValues).length>0);
                  // console.log("1 Option");
                  if(this.conditionType === 'is-in') { // OR
                    // TRUE IF Intersection of( (propertyIds and propertyID:Value) and this current IDS properties) greater than 0  OR  Intersection of( List of ids with values and this current IDS:values properties) greater than 0
                      res = isCurrentPropertiesInList;
                  }else if(this.conditionType === 'is-not-in'){ // NOR
                      res = !isCurrentPropertiesInList;
                  }
                  // console.log("Op 1: "+res);
              }else if(this.isAND){
                  // console.log("2 Option");

                // this.currentPropertyIds => [1,2,6]
                // this.currentPropertyIdsValues => ["2:45", "5:345", ]
                // this.listOfPropertiesOnlyIdsAND => userEntry in array = []
                // this.listOfPropertiesWithValuesAND => userEntry in array = ["2:45"]

                // The new function implemented isListOneSubsetofListTwo, avoid the necessity of check if a list is empty, here the case [] is in [1,2,3,4] == true,
                res = false;
                let isAllUserListInCurrentProperties = ( this.isListOneSubsetOfListTwo(this.listOfPropertiesOnlyIdsAND, this.currentPropertyIds )  && this.isListOneSubsetOfListTwo(this.listOfPropertiesWithValuesAND, this.currentPropertyIdsValues) );
                  if(this.conditionType === 'is-in') {
                    res = isAllUserListInCurrentProperties;

                  }else if(this.conditionType === 'is-not-in'){
                    res = !isAllUserListInCurrentProperties;
                  }
                  // console.log("Op 2: "+res);
              }else{
                // console.log("3 Option");
                let isValueInCurrentProperties = (this.including(this.listPropertiesNoSpaces, this.currentPropertyIds) || this.including(this.listPropertiesNoSpaces, this.currentPropertyIdsValues));
                if(this.conditionType === 'is-in') {
                    res = isValueInCurrentProperties;
                }else if(this.conditionType === 'is-not-in'){
                    res = !isValueInCurrentProperties ;
                }
                // console.log("Op 3: "+res);
              }

              return res;
          },



          currentPropertyIdsValues () {  // List of all current propertyIds with Value List of strings
                const itemID = this.$store.getters.currentItemVariation.item.id;
                const variationProperties = this.$store.state.items[itemID].variation.documents[0].data.variationProperties;

                let idsValuesIncluded = [];
                // console.log("currentPropertyValue");
                if (variationProperties != undefined) {
                    // console.log("Properties: "+JSON.stringify(variationProperties));
                    variationProperties.forEach(propertyGroupL1 =>{

                      if( propertyGroupL1.properties !== 'undefined' ){

                        propertyGroupL1.properties.forEach( propertyGroupL2 => {
                          if(propertyGroupL2.values !== undefined && propertyGroupL2.values !== null ){
                            if(Array.isArray(propertyGroupL2.values)){ // Case when values are array

                              propertyGroupL2.values.map( value => {
                                idsValuesIncluded.push(propertyGroupL2.id+":"+this.transformString(value.value));
                              })

                            }else if( typeof propertyGroupL2.values === 'object'){ // Case when values are only one object, ignoring arrays
                              // console.log(propertyGroupL2.values)
                              idsValuesIncluded.push(propertyGroupL2.id+":"+this.transformString(propertyGroupL2.values.value));

                            }else{ // Case when text or any other type
                              console.log('Found neither object nor array')


                            }
                          }else{
                            idsValuesIncluded.push(propertyGroupL2.id + "");
                          }

                        })

                      }

                    });
                }
                return idsValuesIncluded;
            },

          currentPropertyIds () {  // List of all current property IDS List of integers
                const itemID = this.$store.getters.currentItemVariation.item.id;
                const variationProperties = this.$store.state.items[itemID].variation.documents[0].data.variationProperties;

                // let propertiesDefinedObject = {};
                let idsIncluded = [];
                // console.log("currentProperty");
                if (variationProperties !== undefined) {

                  variationProperties.forEach( propertyGroupL1 => { // For each group of properties iterate over each property and add the property ID to a list of IDS
                    if(propertyGroupL1.properties !== undefined){
                      // console.log("Property Group" ,propertyGroupL1.properties)
                      idsIncluded = idsIncluded.concat(propertyGroupL1.properties.map( propertyGroupLevel2 => propertyGroupLevel2.id))
                    }
                  })

                }
                return idsIncluded;
            },



          listPropertiesNoSpaces (){
            return this.listProperties.replace(/ /g, '');
          },

          isOR(){
            return this.listPropertiesNoSpaces.includes(",")
          },

          isAND(){
            return this.listPropertiesNoSpaces.includes(";")
          },

          listOfPropertiesMixed(){
            let listMixed =  this.listPropertiesNoSpaces.split(',');
            return listMixed.map( value => {
              let el = this.transformString(value);
              if(!isNaN(el)){ // Is a number?
                return parseInt(el, 10)
              }else{
                return el
              }
            });  // Check each value if typeof string and lowercase value
          },

          listOfPropertiesWithValuesAND () {
              //let example = "1:V1;13; 21:V 4";
              // const listT = this.listProperties.replace(/ /g, '');
              //const listT = example.replace(/ /g, '');
              const listFinal = this.listPropertiesNoSpaces.split(';');
              let arrayIds = [];
              if(this.listPropertiesNoSpaces.includes(":")){
                arrayIds = listFinal.filter( element => {
                  if(element.includes(':')){
                    return this.transformString(element)
                  }
                })
              }
              return arrayIds
          },

          listOfPropertiesOnlyIdsAND () {
            //let example = "12:25;12; 21:V4";
            const listFinal = this.listPropertiesNoSpaces.split(';');
            let arrayIds = [];
            arrayIds = listFinal
                .filter(el => !el.includes(':'))
                .map(value => parseInt(value,10))
            return arrayIds
          },

        },

        mounted () {
            this.loading = false;
        },

        methods: {

          transformString(value){
            if(typeof value === 'string'){
              value = value.replace(/ /g, '');
              value = value.toLowerCase();
              return value
            }
            return value
          },
          intersect(listA, listB){
            // console.log("intersect, A: ",listA, ", B: ",listB);
            return listA.filter(valueFromA => listB.includes(valueFromA)) // Check if each value in ListA is in listB, if yes, add it to list.
            // console.log("Intersection List: "+ listA.filter(valueFromA => listB.includes(valueFromA)));
          },

          including(element, list){
              return list.includes(element) // Only returns true if element is included in list
          },

          isListOneSubsetOfListTwo(listOne, listTwo){ // This means all values contained in one list are contained in the second list
            return listOne.every( value => listTwo.includes(value))
          },
        },

        data(){
          return{
            loading: true
          }
        }
    }
</script>
